<div class="wrapper">
  <h2 mat-dialog-title>Skapa ny maskin</h2>
  <mat-dialog-content>
    <div class="form-container">
      <form class="detail-form" [formGroup]="machineForm">
        <div class="machine-form">
          <div class="field-container">
            <mat-form-field appearance="outline" floatLabel="always" class="machine-form-field">
              <mat-label>Maskintyp</mat-label>
              <mat-select formControlName="machineType">
                @for(machineType of machineTypeEnum; track machineType)
                {
                <mat-option [value]="machineType">{{ machineTypeLabels[machineType] }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="field-container">

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Ägartyp</mat-label>
              <mat-select formControlName="ownerType">
                @for(ownerType of ownerTypeEnum; track ownerType)
                {
                <mat-option [value]="ownerType">{{ ownerTypeLabels[ownerType] }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (machineForm.value.ownerType != null && machineForm.value.ownerType == 2) {
          <div class="field-container">

            <mat-form-field appearance="outline" floatLabel="always" style="position: relative;">
              <mat-label>Ansvarig entreprenör</mat-label>
              <mat-select formControlName="machineOwnerId">            
                @for(contractor of allContractors; track contractor)
                {
                  <mat-option [value]="contractor.id">{{ contractor.companyName }}</mat-option>
                }
              </mat-select>         
            </mat-form-field>
          </div>
          }

          <div class="field-container">

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Tillverkare</mat-label>
              <mat-select formControlName="machineManufacturerId">
                @if (definitionService.isLoading())
                {
                <mat-option>Loading...</mat-option>
                }
                @for(manufacturer of definitionService.machineManufacturers(); track manufacturer)
                {
                <mat-option [value]="manufacturer.id">{{ manufacturer.name }}</mat-option>
                }
              </mat-select>

              @if (definitionService.isLoading())
              {
              <mat-progress-spinner matSuffix diameter="16" mode="indeterminate">
              </mat-progress-spinner>
              }
              @if (definitionService.error())
              {
              <mat-error>
                {{ definitionService.error() }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="field-container">

            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Modell</mat-label>
              <mat-select formControlName="machineManufacturerModelId">
                @if (definitionService.isLoading())
                {
                <mat-option>Loading...</mat-option>
                }
                @for(manufacturerModel of definitionService.machineManufacturerModels(); track
                manufacturerModel)
                {
                <mat-option [value]="manufacturerModel.id">{{ manufacturerModel.name }}</mat-option>
                }
              </mat-select>

              @if (definitionService.isLoading())
              {
              <mat-progress-spinner matSuffix diameter="16" mode="indeterminate">
              </mat-progress-spinner>
              }

              @if (definitionService.error())
              {
              <mat-error>
                {{ definitionService.error() }}
              </mat-error>
              }
            </mat-form-field>
          </div>

        </div>
      </form>
    </div>
    <div class="button-container">
      <button class="create-button" mat-button matTooltip="Skapa ny" (click)="cancel()">Avbryt
      </button>
      <button mat-button="outlined" class="create-button" mat-raised-button matTooltip="Skapa ny" (click)="save()"
        [disabled]="!allInputsHaveValue()">Skapa
        maskin
      </button>
    </div>
  </mat-dialog-content>
</div>